export abstract class DashboardPagesConfiguration {
  public static CustomPageTitles: { [key: string]: string } = {};
}
